import { useEffect, useReducer } from "react";

// Re-renders the caller whenever the shell fires one of `types`, and every `everyMs` if given
// (held items fade with time, so the memory panel refreshes once a minute).
export function useShellEvents(shell, types, everyMs) {
  const [, bump] = useReducer(n => n + 1, 0);
  const key = types.join(",");
  useEffect(() => {
    if (!shell) return undefined;
    const offs = key.split(",").map(t => shell.on(t, bump));
    const timer = everyMs ? setInterval(bump, everyMs) : null;
    return () => {
      offs.forEach(off => off());
      clearInterval(timer);
    };
  }, [shell, key, everyMs]);
}
